import axios from 'axios'

export const useProductRequests = () => {
  const cacheMod = false;
  const getProducts = async (data={}) => { 
    /*
      page=${data.page||"1"}&
      name=${data.name||""}&
      description=${data.description||""}&
      price=${data.price||""}&
      stock=${data.stock||""}&
      slug=${data.slug||""}&
      categorySlug=${data.category||""}&
      sort=${data.sort||""}&
      allSearch=${data.allSearch||""}
    */
    
    return axios({
      method: 'POST',
      url: `${process.env.REACT_APP_API+process.env.REACT_APP_PRODUCTS}`,
      data:data,
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        'Target-URL' : `${process.env.REACT_APP_API+process.env.REACT_APP_PRODUCTS}/?count=10`,
        'Authorization': `${localStorage.getItem('sarfnettoken')}`
      }
    })
  }
  const getMainProductRequest = async (data) => {
    return axios({
      method: "GET",
      url: `${
        process.env.REACT_APP_API + process.env.REACT_APP_MAIN_PRODUCTS
      }?type=${data.type}`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Target-URL": `${
          process.env.REACT_APP_API + process.env.REACT_APP_MAIN_PRODUCTS
        }/?count=10`,
        Authorization: `${localStorage.getItem("sarfnettoken")}`,
      },
    });
  }
  const getMainProducts = async (data = {}) => {
    const cached = localStorage.getItem("sarfnetmainproducts" + (data.type+""));
    var currentDate = new Date();
    var secondsSinceEpoch = currentDate.getTime() / 1000;
    if (cached != null && cacheMod==true) {
      const check = await JSON.parse(cached);
      if (check.timestamp > secondsSinceEpoch) {
        return check.data;
      }
    }
    
    const result = await getMainProductRequest(data);
    localStorage.setItem(
      "sarfnetmainproducts" + (data.type + ""),
      JSON.stringify({
        timestamp: secondsSinceEpoch + 60 * 60,
        data: result,
      })
    );
    return result;
  };

  const getProduct = async (id) => { 
    return axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API+process.env.REACT_APP_PRODUCT}?slug=${id}`,
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        'Target-URL' : `${process.env.REACT_APP_API+process.env.REACT_APP_PRODUCTS}/${id}`,
        'Authorization': `${localStorage.getItem('sarfnettoken')}`
      }
    })
  }

  

  const getDiscover = async (data={}) => {
    
    return axios({
      method: 'POST',
      url: `${process.env.REACT_APP_API+process.env.REACT_APP_PRODUCTS}`,
      data:data,
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        'Authorization': `${localStorage.getItem('sarfnettoken')}`
      }
    })
  }

  const getCategoryRequest = async () => {
    return axios({
      method: "GET",
      url: `${process.env.REACT_APP_API + process.env.REACT_APP_CATEGORIES}`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `${localStorage.getItem("sarfnettoken")}`,
      },
    });
  }

  const getCategories = async (count=null) => {
    
    const cached = localStorage.getItem("sarfnetcategories" );
    var currentDate = new Date();
    var secondsSinceEpoch = currentDate.getTime() / 1000;
    if (cached != null && cacheMod==true ) {
      const check = await JSON.parse(cached);
      if (check.timestamp > secondsSinceEpoch) {
        return check.data;
      }
    }
    const result = await getCategoryRequest();
    localStorage.setItem(
      "sarfnetcategories" ,
      JSON.stringify({
        timestamp: secondsSinceEpoch + 60 * 60,
        data: result,
      })
    );
    return result;

  }



  const getBrands = async (count=null) => {
    return axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API+process.env.REACT_APP_BRANDS}`,
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        'Authorization': `${localStorage.getItem('sarfnettoken')}`

      }
    })
  }
  const getCampaignRequest = async (type) => {
    return axios({
      method: "GET",
      url: `${
        process.env.REACT_APP_API + process.env.REACT_APP_GET_IMAGES
      }?pass=ds.is.selected.2023&type=${type}`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `${localStorage.getItem("sarfnettoken")}`,
      },
    });
    
  }
  const getCampaigns = async (type = "campaign") => {
    const cached = localStorage.getItem(
      "sarfnetcampaigns"+type
    );
    var currentDate = new Date();
    var secondsSinceEpoch = currentDate.getTime() / 1000;
    if (cached != null && cacheMod==true) {
      const check = await JSON.parse(cached);
      if (check.timestamp > secondsSinceEpoch) {
        return check.data;
      }
    }
    const result = await getCampaignRequest(type);
    localStorage.setItem(
      "sarfnetcampaigns" + type,
      JSON.stringify({
        timestamp: secondsSinceEpoch + 60 * 60,
        data: result,
      })
    );
    return result;
  };
  
  return {
    getProducts,
    getProduct,
    getDiscover,
    getCategories,
    getBrands,
    getMainProducts,
    getCampaigns,
  };
}